import React,{useEffect,useState} from 'react'
import '../Assets/Css/services.css';
import { Helmet } from 'react-helmet';
import { Container, Row, Col, Button ,ListGroup } from 'react-bootstrap';
import { IoArrowForwardCircleOutline } from "react-icons/io5";
import { FaLeaf, FaFish, FaTint, FaSolarPanel, FaIndustry, FaCapsules, FaCity } from 'react-icons/fa';
import AOS from 'aos';
import 'aos/dist/aos.css';

import specialties1 from '../Assets/Images/specialties1.avif'
import specialties2 from '../Assets/Images/specialties2.avif'
import specialties3 from '../Assets/Images/specialties33.jpg'
import specialties4 from '../Assets/Images/specialties4.jpg'
import specialties5 from '../Assets/Images/specialties5.avif'

import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import { FaStar } from 'react-icons/fa';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

export default function Services() {

   useEffect(() => {
      AOS.init({ duration: 1000, once: false });
      AOS.refresh();
    }, []);

  const industries = [
  { title: "Soil Remediation & Regenerative Agriculture", icon: <FaLeaf /> },
  { title: "Food & Feed Production", icon: <FaFish /> },
  { title: "Water Technologies", icon: <FaTint /> },
  { title: "Renewable Fuels & Energies", icon: <FaSolarPanel /> },
  { title: "Textiles & Construction Materials", icon: <FaIndustry /> },
  { title: "Nutraceuticals & Natural Medicines", icon: <FaCapsules /> },
  { title: "Sustainable Community Development", icon: <FaCity /> }
];
 const [activeIndex, setActiveIndex] = useState(0);

const specialties = [
  {
    title: "Analysis",
    image: specialties1,
    description: [
      "Data Analytics and Science",
      "Risk Assessment",
      "Fraud Prevention and Accountability Solutions"
    ]
  },
  {
    title: "Stratigic Planning",
    image:specialties2,
    description: [
      "Project Planning",
      "Development/Resources",
      "Business Development",
      "Business Accelerator",
      "Value Driven Solutions Provider",
      "Value Driven Focus"
    ]
  },
  {
    title: "Development Systems",
    image: specialties3,
    description: [
      "Research & Development",
      "Education and Training Programs",
      "Technology Resources and Efficiencies"
    ]
  },
  {
    title: "Marketing and sales",
    image: specialties4,
    description: [
      "Strategic Marketing",
      "Sales Channels",
      "Spokespeople",
      "Whole material supply",
      "Distributor Relationships",
      "Master Aggregator"
    ]
  },
  {
    title: "Management Services",
    image: specialties5,
    description: [
      "Management Services and Development",
      "Corporate Culture Development",
      "Operations",
      "Business Relationships",
      "Banking Relationships",
      "Investor Relationships",
      "Administration - Accounting, EDI, Blockchain",
      "Human Resources - Team building culture",
      "Risk Mitigation",
      "Logistics Resources"
    ]
  }
];

const testimonials = [
    "Mobius Unity helped us scale our regenerative agriculture practices by offering strategic insights and data-driven planning. Their team truly understands how to blend nature-based solutions with innovation.",
    "The technical and operational support from Mobius Unity was crucial to our success in deploying water-saving technologies in remote communities. Their collaborative approach made all the difference.",
    "Their strategic planning and risk assessment services gave us a clear roadmap to scale our solar microgrid systems. They don't just consult — they become part of your journey.",
    "Mobius Unity’s work on sustainable community models and business-government engagement has set a new benchmark in how private organizations support public initiatives.",
    "From market strategy to operations, their team brought structure and momentum to our vision. Mobius Unity's values align perfectly with impact-driven entrepreneurs like us.",
  ];

  return (
    <div style={{ minHeight: '100vh' }}>
       <Helmet>
      {/* Page Title */}
      <title>Our Services | Sustainable Development & Innovation | Mobius Unity Consulting</title>

      {/* Meta Description */}
      <meta
        name="description"
        content="Explore our strategic consulting services for sustainable development, circular economies, soil remediation, water technology, and more. We co-create impactful solutions for business and community growth."
      />

      {/* Keywords */}
      <meta
        name="keywords"
        content="Mobius Unity Consulting services, sustainability consulting, circular economy, regenerative agriculture, soil remediation, business development, strategic planning, water technologies, renewable energy, nutraceuticals, natural medicines, risk assessment, data analytics"
      />

      {/* Author */}
      <meta name="author" content="Mobius Unity Consulting" />

      {/* Canonical URL */}
      <link rel="canonical" href="https://mobiusunityconsulting.com/services" />

      {/* Open Graph / Facebook */}
      <meta property="og:title" content="Our Services | Mobius Unity Consulting" />
      <meta
        property="og:description"
        content="Deliverable concepts that generate shared impact values. Explore how Mobius Unity Consulting can help you build a thriving, sustainable future through custom strategy and innovation."
      />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://mobiusunityconsulting.com/services" />
      <meta property="og:image" content="https://mobiusunityconsulting.com/assets/services-og-image.jpg" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Our Services | Mobius Unity Consulting" />
      <meta
        name="twitter:description"
        content="Strategic consulting and development services that empower communities, businesses, and industries for long-term growth and sustainability."
      />
      <meta name="twitter:image" content="https://mobiusunityconsulting.com/assets/services-twitter-image.jpg" />
      <meta name="twitter:site" content="@MobiusUnity" />
    </Helmet>
     
       <div className=" bannerecommer-section d-flex align-items-center justify-content-center">
          <div className="bannerecommer-overlay text-center" data-aos="zoom-in">
            <h2 className="banner1-title">Our Services</h2>
            <p className="banner1-subtitle" data-aos="zoom-in" data-aos-delay="200">
              Deliverable concepts that Generate Shared Impact Values
            </p>

          </div>
        </div>

<section className="py-5" style={{ backgroundColor: '#F8FBFF' }}>
  <Container>
    <Row className="justify-content-center mb-4">
      <h3
          className="fw-bold text-center section-title"
          data-aos="fade-down"
          data-aos-delay="100"
        >
          Service & Value-Based <br />
          <span style={{ color: '#04A1D3' }}> Development Consulting</span>
          <span className="title-decoration d-block mx-auto mb-2"></span>
        </h3>
      <Col md={10}>
        
      </Col>
    </Row>

    <Row className="justify-content-center">
      <Col md={10} className="custom-box p-4" data-aos="zoom-in">
        <p style={{ textAlign: 'justify' }}>
          At <strong>Mobius Unity Consulting</strong>, we offer a wide range of services to help our clients achieve their sustainable business and community development goals. Our services include analysis, strategic planning, development systems, marketing and sales, and management services.
        </p>
        <p style={{ textAlign: 'justify' }}>
          We specialize in circular economies, soil remediation, innovative technologies, entrepreneurship, job creation and more. Our team of experts will work with you to develop customized solutions that meet your unique needs and goals.
        </p>
        <p style={{ textAlign: 'justify' }}>
          Contact us today to learn more about how we can help your business thrive while making a positive impact on the environment and the communities you serve.
        </p>
      </Col>
    </Row>
  </Container>
</section>


      {/* Focused Industries */}
    <section className="py-5 ">
  <Container>
    <Row className="text-center mb-5" data-aos="fade-down">
                  <Col>
                    <h3 className="fw-bold section-title">
                      Our Focused<span style={{ color: '#04A1D3' }}> Industries</span>
                      <span className="title-decoration">  </span>
                    </h3>
                  </Col>
                </Row>
    <Row className="gx-4 gy-4 justify-content-center" data-aos="fade-up">
      {industries.map((item, index) => (
        <Col key={index} xs={12} sm={6} md={3}>
          <div className="industry-icon-card text-center">
            <div className="icon-wrapper mb-3">{item.icon}</div>
            <p className="industry-title">{item.title}</p>
          </div>
        </Col>
      ))}
    </Row>
  </Container>
</section>

<section className="py-5">
      <Container>
        <Row className="text-center mb-5" data-aos="fade-down">
          <Col>
            <h3 className="fw-bold section-title">
              Our <span style={{ color: '#04A1D3' }}> Specialities</span>
              <span className="title-decoration"> </span>
            </h3>
            <p>
             <strong>Note: </strong>  Some of the items may be put in multiple categories depending on the context and the specific consulting focus.
            </p>
          </Col>
        </Row>

        <Row className="justify-content-center">
 <Col md={10}>
  <Row className="specialty-wrapper gx-0">
    {/* Sidebar with background image */}
    <Col md={4} className="sidebar-col d-flex align-items-center">
      <ListGroup variant="flush" className="specialty-tabs w-100">
        {specialties.map((item, index) => (
          <ListGroup.Item
            key={index}
            action
            active={index === activeIndex}
            onClick={() => setActiveIndex(index)}
            className="fw-medium text-center"
          >
            {item.title}
          </ListGroup.Item>
        ))}
      </ListGroup>
    </Col>

    {/* Content area with white background */}
    <Col md={8} className="content-col text-center">
      <div className="specialty-detail p-4 text-center">
        <img
          src={specialties[activeIndex].image}
          alt={specialties[activeIndex].title}
          className="img-fluid specialityimg rounded mb-3 mx-auto d-block"
        />
        <h5 className="fw-bold mb-3">{specialties[activeIndex].title}</h5>
        <ul className="text-start d-inline-block text-wrap">
          {specialties[activeIndex].description.map((desc, i) => (
            <li key={i}>{desc}</li>
          ))}
        </ul>
      </div>
    </Col>
  </Row>
</Col>
</Row>

      </Container>
    </section>


     

      {/* Final CTA */}
      <section className="py-5 text-white" style={{ backgroundColor: '#036839' }}>
        <Container className="text-center">
           <Row className="text-center " data-aos="fade-down">
                  <Col>
                    <h3 className="text-white fw-bold section-title">
                    Let’s Support  Each Other
                      <span className="title-decoration">  </span>
                    </h3>
                  </Col>
                </Row>
        
          <p className=" mb-4" data-aos="fade-up" style={{ maxWidth: 800, margin: '0 auto',lineHeight:'2' }}>
            At Mobius Unity Consulting, we are committed to creating sustainable and impactful solutions for our clients. We believe that the first step to achieving success is through a simple conversation.
            <br />
            Contact us today and let’s work together to create a better future for your business, your community, and the world.
          </p>
           <Button variant="light" className="banner1-button " href='/contact'
                        data-aos="zoom-in" data-aos-delay="300">
                       Connect Us <IoArrowForwardCircleOutline size={30} style={{ animation: 'pulse 1.5s infinite', transformOrigin: 'center' }} />
                      </Button>
        </Container>
      </section>

      <section className="testimonial-carousel-section my-5">
                <div className="container py-3 ">
                  <Row className="align-items-center justify-content-center flex-md-row m-0">
                    <h3 className="fw-bold text-center section-title" data-aos="fade-down" data-aos-delay="100">
                      Empowering <span style={{ color: '#04A1D3' }}>Innovation</span>
                      <span className="title-decoration mb-2"></span>
                    </h3>
                    <p className="text-muted text-center" style={{ maxWidth: 700 }} data-aos="fade-down" data-aos-delay="100">
                      we deliver smart solutions that empower growth and innovation.
                    </p>
                    <Col xs={12} md={8} className="text-center order-1 order-md-2" data-aos="zoom-in" data-aos-delay="200">
      
                      <Swiper
                        modules={[Autoplay, Pagination, Navigation]}
                        spaceBetween={30}
                        loop={true}
                        autoplay={{
                          delay: 5000,
                          disableOnInteraction: false,
                        }}
                        pagination={{ clickable: true }}
                        navigation={true}
                        className="testimonial-swiper"
                      >
                        {testimonials.map((text, idx) => (
                          <SwiperSlide key={idx}>
                            <div className="stars mb-1">
                              {[...Array(5)].map((_, i) => (
                                <FaStar key={i} color="#036839" />
                              ))}
                            </div>
                            <p className="testimonial-quote">
                              <span className="quote-mark">“</span>
                              {text}
                              <span className="quote-mark">”</span>
                            </p>
                            <p className="author-name">Anonymous</p>
                          </SwiperSlide>
                        ))}
                      </Swiper>
                    </Col>
                  </Row>
                </div>
              </section>

    </div>
  )
}
